module.exports = __webpack_public_path__ + "static/img/wlw_d_pt.ad93aceb.png";